/**
 * useNotificationSound — tono de notificación generado con Web Audio API.
 * No requiere archivos de audio. Compatible con iOS en modo standalone.
 */
import { useRef, useCallback } from "react";

export function useNotificationSound() {
  const ctxRef = useRef(null);

  const play = useCallback(() => {
    try {
      if (!window.AudioContext && !window.webkitAudioContext) return;
      const ctx = ctxRef.current || new (window.AudioContext || window.webkitAudioContext)();
      ctxRef.current = ctx;

      // iOS Safari puede tener el contexto "suspended" hasta interacción del usuario
      if (ctx.state === "suspended") ctx.resume();

      // Doble tono tipo "chime": Re5 (587Hz) → La5 (880Hz)
      const tones = [587, 880];
      tones.forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = "sine";
        osc.frequency.value = freq;
        const t = ctx.currentTime + i * 0.13;
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(0.18, t + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.001, t + 0.38);
        osc.start(t);
        osc.stop(t + 0.4);
      });
    } catch {
      // silently fail — never break the UI
    }
  }, []);

  return play;
}
